var _style, _circle, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgError404 = function SvgError404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#CCCCCC;}\r\n\t.st2{fill:#B3B3B3;}\r\n\t.st3{fill:#E6E6E6;}\r\n\t.st4{fill:#FF6F35;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358,381.2l-66.5-97.6H170.8l66.5,97.6c4.7,6.8,7,14.9,6.5,23.2c-0.3,4.9-1.5,9.8-3.7,14.2 c-6.2,13.1-19.4,21.4-33.8,21.3H327C357.2,439.9,375,406.2,358,381.2z M293.5,383.1c-7.9,0-15.3-4-19.7-10.5l-10.7-17.9h35.5l5,9.4 c1.4,2,2.1,4.3,2.1,6.8C305.7,377.6,300.3,383.1,293.5,383.1C293.5,383.1,293.5,383.1,293.5,383.1L293.5,383.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.3,404.4v14.2h-37.2c2.1-4.4,3.4-9.3,3.7-14.2H277.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.5,404.4h14.2v14.2h-14.2V404.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.9,404.4h14.2v14.2h-14.2V404.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.3,425.7h127.9c3.9,0,7.1,3.2,7.1,7.1l0,0c0,3.9-3.2,7.1-7.1,7.1H206.3c-3.9,0-7.1-3.2-7.1-7.1l0,0 C199.2,428.9,202.4,425.7,206.3,425.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.4,113.2h28.4c7.8,0,14.2,6.4,14.2,14.2v213.1c0,7.8-6.4,14.2-14.2,14.2h-28.4V113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.2,113.2h355.2c7.8,0,14.2,6.4,14.2,14.2v213.1c0,7.8-6.4,14.2-14.2,14.2H64.2c-7.8,0-14.2-6.4-14.2-14.2 V127.4C50,119.5,56.4,113.2,64.2,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.6,141.6H391c7.8,0,14.2,6.4,14.2,14.2v156.3c0,7.8-6.4,14.2-14.2,14.2H92.6c-7.8,0-14.2-6.4-14.2-14.2 V155.8C78.4,148,84.8,141.6,92.6,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131,297.9h221.5c7.8,0,14.2-6.4,14.2-14.2c0-2.4-0.6-4.8-1.8-6.9L254.2,78.5c-3.8-6.8-12.5-9.3-19.3-5.5 c-2.3,1.3-4.2,3.2-5.5,5.5L118.6,276.7c-3.8,6.8-1.4,15.5,5.5,19.3C126.2,297.2,128.6,297.9,131,297.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 241.8,
    cy: 255.2,
    r: 14.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M263.1,148.7h-42.6l14.2,63.9h14.2L263.1,148.7z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-404.f21aa300.svg";
export { ForwardRef as ReactComponent };